import React from 'react'
import { CenterBox } from '@repo/ui/components/center-box'
import { Typography } from '@repo/ui/components/typography'
import { useTranslate } from '@repo/shared/hooks'
import Image from 'next/image'

export const ProjectsDetailOrderBoxEmptyState = ({
  status,
}: {
  status:
    | 'coming_soon'
    | 'active'
    | 'suspended'
    | 'delisting'
    | 'off_market'
    | string
    | undefined
}) => {
  const { t } = useTranslate()

  return (
    <CenterBox className=' flex-col gap-lg py-10xl'>
      <Image
        src={`/images/project-status/${status}.svg`}
        alt='coin'
        width={64}
        height={64}
      />

      <Typography
        variant='p'
        size='sm'
        color='text-neutral-surface-100'
        className='text-center'
      >
        {status && t(`common_project_trade_status_${status}_description`)}
      </Typography>
    </CenterBox>
  )
}
